module.exports = __webpack_public_path__ + "img/executor.27882ee2.svg";